var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-overlay',{staticClass:"h-100",attrs:{"show":_vm.loading && !!_vm.items.length,"rounded":"sm"}},[_c('router-view',{attrs:{"name":"feed"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }